
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.042 2.288a1.125 1.125 0 00-.908-1.79H1.125A1.125 1.125 0 00.211 2.28l3.55 5.085v4.008a1.13 1.13 0 001.226 1.125c.277.008.55-.062.787-.204 1.366-.85 1.222-.762 1.235-.771a1.13 1.13 0 00.45-.9V7.367l3.583-5.079zm-4.718 4.52a.625.625 0 00-.115.36v3.241a.25.25 0 01-.122.215c-.164.097-.461.274-.702.413a.25.25 0 01-.376-.216V7.17a.621.621 0 00-.112-.358l-3.259-4.67a.25.25 0 01.205-.392h7.568a.25.25 0 01.204.394L6.324 6.808z","fill":"#000"}})])
          )
        }
      }
    